import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
// 路由懒加载
const _import =(file) => () => import('@/' + file)

//路由
export const  constantRoutes = [
{
path: '/',
redirect: { name: 'XrgfTkSiEi' },
},


{
path:'/pages/XrgfTkSiEi',
name: 'XrgfTkSiEi',
component: _import('pages/XrgfTkSiEi.vue'),
meta: {
title:'首页'
}
}, 



{
path:'/pages/vuXgIXCjQC',
name: 'vuXgIXCjQC',
component: _import('pages/vuXgIXCjQC.vue'),
meta: {
title:'客户案例列表'
}
}, 



{
path:'/pages/ZsBoXShqhK',
name: 'ZsBoXShqhK',
component: _import('pages/ZsBoXShqhK.vue'),
meta: {
title:'客户案例详情智慧大棚'
}
}, 



{
path:'/pages/DkBDYtmAES',
name: 'DkBDYtmAES',
component: _import('pages/DkBDYtmAES.vue'),
meta: {
title:'客户案例渭南妇联官网'
}
}, 



{
path:'/pages/IGdldEOQCU',
name: 'IGdldEOQCU',
component: _import('pages/IGdldEOQCU.vue'),
meta: {
title:'客户案例渭南智慧湭河水库'
}
}, 



{
path:'/pages/wvweQhEhqx',
name: 'wvweQhEhqx',
component: _import('pages/wvweQhEhqx.vue'),
meta: {
title:'客户案例医共体'
}
}, 



{
path:'/pages/mykumCnjWV',
name: 'mykumCnjWV',
component: _import('pages/mykumCnjWV.vue'),
meta: {
title:'客户案例工农社区'
}
}, 



{
path:'/pages/qkdgMRKtPj',
name: 'qkdgMRKtPj',
component: _import('pages/qkdgMRKtPj.vue'),
meta: {
title:'平台特色'
}
}, 



{
path:'/pages/yNJTrGrgLW',
name: 'yNJTrGrgLW',
component: _import('pages/yNJTrGrgLW.vue'),
meta: {
title:'作品社区'
}
}, 



{
path:'/pages/YsyYRfJolJ',
name: 'YsyYRfJolJ',
component: _import('pages/YsyYRfJolJ.vue'),
meta: {
title:'下载'
}
}, 



{
path:'/pages/bgOImykdTk',
name: 'bgOImykdTk',
component: _import('pages/bgOImykdTk.vue'),
meta: {
title:'企业服务'
}
}, 



{
path:'/pages/JXjFBFIlSe',
name: 'JXjFBFIlSe',
component: _import('pages/JXjFBFIlSe.vue'),
meta: {
title:'营业执照'
}
}, 



{
path:'/pages/VOfuplkExt',
name: 'VOfuplkExt',
component: _import('pages/VOfuplkExt.vue'),
meta: {
title:'视频教程'
}
}, 



{
path:'/pages/EGEKEUtryB',
name: 'EGEKEUtryB',
component: _import('pages/EGEKEUtryB.vue'),
meta: {
title:'隐私政策'
}
}, 



{
path:'/pages/xXBMEGrtcf',
name: 'xXBMEGrtcf',
component: _import('pages/xXBMEGrtcf.vue'),
meta: {
title:'使用协议'
}
}, 


]
const router = new VueRouter({
mode: 'hash',
base: './',
routes:constantRoutes
})
export default router